import styled from 'styled-components';

export const DepositSurveyStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    text-align: center;
    
    h3 {
        color: var(--color-white);
        font-weight: 700;
        font-size: 32px;
    }
    
    p {
        margin: 16px 0 0;
    }
    
    .btn-outline {
        color: var(--color-white-60);
    }
`;

export const DepositSurveyAnswersContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
`;

export const DepositSurveyAnswerStyled = styled.div`
    display: flex;
    align-items: center;
    padding: 16px 12px;
    background: var(--color-neutral-10);
    border-radius: 12px;
    
    :hover,
    &.selected {
        background: var(--color-neutral-20);
    }
    
    > span {
        margin-left: 12px;
        font-size: 16px;
        color: var(--color-white-95);
        text-align: left;
    }
`;

export const DepositSurveyButtonsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
`;
